import { ICoordinates } from "../salesforce";

export interface IDealer {
  name: string
  address: string
  advisor: string
  linkAddress?: string
  coordinates?: ICoordinates
}
